import { render } from "./HomeBroadcastVideo.vue?vue&type=template&id=13960e5a"
import script from "./HomeBroadcastVideo.vue?vue&type=script&lang=ts"
export * from "./HomeBroadcastVideo.vue?vue&type=script&lang=ts"

import "./HomeBroadcastVideo.vue?vue&type=style&index=0&id=13960e5a&lang=postcss"
script.render = render

export default script